import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiDialogContent(theme: Theme): Components['MuiDialogContent'] {
  return {
    variants: [
      {
        props: { margin: 'none' },
        style: {
          padding: '0 !important',
        },
      },
    ],
    styleOverrides: {
      root: {
        padding: theme.spacing(6),
        color: theme.palette.text.primary,
        borderTop: 0,
        borderBottom: 0,
      },
    },
  };
}
